module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('em', [_vm._v("Anniversaries")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9-1.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "section"
  }, [_vm._v("On Our Special Anniversary")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("I may not always show you"), _c('br'), _vm._v("\nAnd I may not always say"), _c('br'), _vm._v("\nHow much you really mean to me"), _c('br'), _vm._v("\nIn every kind of way")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("So on this special day of ours"), _c('br'), _vm._v("\nI would like the world to know"), _c('br'), _vm._v("\nHow much I really need you"), _c('br'), _vm._v("\nAnd how I truly love you so")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/10-1.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section"
  }, [_c('em', [_vm._v("tip")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("You can easily adapt this"), _c('br'), _vm._v(" verse for any type of"), _c('br'), _vm._v(" anniversary by changing"), _c('br'), _vm._v(" the word ‘golden’ and"), _c('br'), _vm._v(" substituting the number"), _c('br'), _vm._v(" of years")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "section"
  }, [_vm._v("On Your Golden"), _c('br'), _vm._v("Wedding Anniversary")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Fifty glorious years together"), _c('br'), _vm._v(" Memories recent, many old"), _c('br'), _vm._v(" May all of them be treasured"), _c('br'), _vm._v(" For they have turned to gold")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/11-1.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "section"
  }, [_c('em', [_c('span', {
    staticClass: "big"
  }, [_vm._v("O")]), _vm._v("n Our Wedding Anniversary")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("I wouldn’t change a single day"), _c('br'), _vm._v("\nThat I have spent with you"), _c('br'), _vm._v("\nThere’s love in everything you say"), _c('br'), _vm._v("\nIn everything you do"), _c('br'), _vm._v("\nYou never need to tell me"), _c('br'), _vm._v("\nHow much you love me so"), _c('br'), _vm._v("\nFor every time I look at you"), _c('br'), _vm._v("\nYour smile just lets me know")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "section"
  }, [_vm._v("Happy Anniversary Mum & Dad")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The love you have for each other is an inspiration to all of us a firm rock which helped me to be the person I am today proud to call you, Mum and Dad")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Celebrate the love you have for each other"), _c('br'), _vm._v(" Recapture happy memories long forgotten"), _c('br'), _vm._v(" Cherish your life together always"), _c('br'), _vm._v(" On this, your anniversary")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "section"
  }, [_vm._v("On your Silver"), _c('br'), _vm._v(" Wedding Anniversary")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("It seems like only yesterday"), _c('br'), _vm._v("\nThat you both said ‘I do’"), _c('br'), _vm._v("\nThe years have gone so quickly"), _c('br'), _vm._v("\nAnd been so kind to you"), _c('br'), _vm._v("\nLots of memories to hold on to"), _c('br'), _vm._v("\nLove and laughter on the way"), _c('br'), _vm._v("\nTreasure them and one another"), _c('br'), _vm._v("\nOn your Silver Wedding Day")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("May this Wedding Anniversary Day bring together a collection of beautiful memories and create dreams of more precious tomorrows")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Each passing year brings me closer to you so close that I can feel what you feel love what you love and know that you were truly heaven sent")])]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_vm._v("HAPPY ANNIVERSARY DARLING")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_c('strong', [_vm._v("Just to say……..")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("of all the people in all the world I’m glad I married you Happy Anniversary Darling")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "section"
  }, [_c('em', [_c('span', {
    staticClass: "big"
  }, [_vm._v("Y")]), _vm._v("ou’re always there each time for me")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("When everything goes wrong"), _c('br'), _vm._v("\nYou cheer me up and make me laugh"), _c('br'), _vm._v("\nYou keep our marriage strong")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("You’re my best friend, my husband"), _c('br'), _vm._v("\nMy lover and much more"), _c('br'), _vm._v("\nThe man I love so very much"), _c('br'), _vm._v("\nThe man that I adore")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("I’m so glad that you asked me"), _c('br'), _vm._v("\nYears ago to be your wife"), _c('br'), _vm._v("\nThe one to share your hopes and fears"), _c('br'), _vm._v("\nThe one to share your life")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("And at this special time of year"), _c('br'), _vm._v("\nThere’s nothing more to say"), _c('br'), _vm._v("\nThan to wish you all you wish yourself"), _c('br'), _vm._v("\nOn our Anniversary")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("No child could wish for parents"), _c('br'), _vm._v("\nMore loving than you two"), _c('br'), _vm._v("\nA daughter could not hope for"), _c('br'), _vm._v("\nMore support to see her through"), _c('br'), _vm._v("\nYou laid a firm foundation"), _c('br'), _vm._v("\nOn which to build my life"), _c('br'), _vm._v("\nSo I could be a mother"), _c('br'), _vm._v("\nA best friend and a wife"), _c('br'), _vm._v("\nThank you for being rock solid"), _c('br'), _vm._v("\nThrough the good times and the bad"), _c('br'), _vm._v("\nBut most of all I bless you both"), _c('br'), _vm._v("\nFor being my Mum and Dad")])]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_vm._v("HAPPY ANNIVERSARY")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("Husband/Wife")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("I love you so, you’re always there"), _c('br'), _vm._v("\nTo comfort me and show you care"), _c('br'), _vm._v("\nI know you always understand"), _c('br'), _vm._v("\nI feel upset, you touch my hand"), _c('br'), _vm._v("\nYou are my reason to exist"), _c('br'), _vm._v("\nI knew that moment we first kissed"), _c('br'), _vm._v("\nI cherish our anniversary"), _c('br'), _vm._v("\nThe day on which you married me"), _c('br'), _vm._v("\nYou are the person I adore"), _c('br'), _vm._v("\nSo here’s to many, many more")])]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_vm._v("Happy Anniversary Darling")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Marriage is a priceless gift"), _c('br'), _vm._v("\nThat makes two people one"), _c('br'), _vm._v("\nThat binds them with a love so strong"), _c('br'), _vm._v("\nTo help them carry on")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Through ups and downs life hands them"), _c('br'), _vm._v("\nHappy days and sometimes sad"), _c('br'), _vm._v("\nThat helps them to discover"), _c('br'), _vm._v("\nWhat it’s like as Mum and Dad")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("To build a world together"), _c('br'), _vm._v("\nA precious family of their own"), _c('br'), _vm._v("\nTo find a house together"), _c('br'), _vm._v("\nThat then becomes a home")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Marriage is a treasure"), _c('br'), _vm._v("\nThat can’t be bought or sold"), _c('br'), _vm._v("\nIt’s a partnership together"), _c('br'), _vm._v("\nWhich, with the years, can turn to gold")])]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_vm._v("HAPPY GOLDEN WEDDING")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/16-1.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_c('strong', [_vm._v("Just to say……..")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("you made two half families into a great whole one Happy Anniversary to you both from all of your children")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Life is not always easy but being with you and sharing our lives is a pleasure that I hope will last forever")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("You really are an angel"), _c('br'), _vm._v("\nWith everyone you meet"), _c('br'), _vm._v("\nYou’re the wife I always dreamed of"), _c('br'), _vm._v("\nYou make my life complete")])]), _vm._v(" "), _c('h1', {
    staticClass: "section"
  }, [_vm._v("HAPPY ANNIVERSARY")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "section"
  }, [_vm._v("HAPPY ANNIVERSARY HUSBAND")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Reflections in the water on a lovely sunny day"), _c('br'), _vm._v("\nRemind me of the day we met and I’d just like to say"), _c('br'), _vm._v("\nYou fill my life with sunshine like a thousand sparkling beams"), _c('br'), _vm._v("\nYou’re my knight in shining armour, the answer to my dreams"), _c('br'), _vm._v("\nThe day we wed seems distant, so far away and yet"), _c('br'), _vm._v("\nIt was magical, a fairytale, a day I won’t forget"), _c('br'), _vm._v("\nFor me it was so special, the beginning of my life"), _c('br'), _vm._v("\nI’m proud of you my husband, proud to be your wife")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "section"
  }, [_c('em', [_vm._v("tip")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Insert the number of years that the couple have been married in the first line, to make it specific to the anniversary")])])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "section"
  }, [_c('em', [_c('span', {
    staticClass: "big"
  }, [_vm._v("S")]), _vm._v("on & Daughter-in-law")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('em', [_vm._v("Or Daughter & Son-in-law")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Three years you’ve spent together"), _c('br'), _vm._v("\nAs devoted man and wife"), _c('br'), _vm._v("\nAnd now somebody special"), _c('br'), _vm._v("\nIs about to share your life"), _c('br'), _vm._v("\nYou’re a really lovely couple"), _c('br'), _vm._v("\nWho both of us adore"), _c('br'), _vm._v("\nAbout to make us ‘grand’ parents"), _c('br'), _vm._v("\nWell who could ask for more"), _c('br'), _vm._v("\nSo on your anniversary"), _c('br'), _vm._v("\nWe wish you both good cheer"), _c('br'), _vm._v("\nFor your wedding celebrations"), _c('br'), _vm._v("\nAnd throughout the coming year")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43bca07d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c01.vue
// module id = 72
// module chunks = 0